import React from 'react'

function Location() {
  return (
    <div>
        <a href="https://www.google.com/maps/search/Dietitian+Clinic+Ventu+Life+Center+ANFORA+Clinic/@14.0598226,-87.2294768,17z/data=!3m1!4b1" rel="noreferrer" target="_blank">
            <img src='./images/clinic.png' alt='' /></a>
    </div>
  )
}

export default Location